import axios from "axios";

let location = window.location.origin;
const API = `${location}/api/GetAllParks`;

export default {
    get() {
        return axios.post(API);
    },
    create(todo) {}
};